import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {CookieTypesEnum} from '../../enums/cookie-types.enum';
import {BaseComponent} from '../../../core/abstractions/base.component';
import {CookieSettingsModel} from '../../models/cookieSettings.model';
import {AppService} from '../../services/app.service';

@Component({
    selector: 'app-cookie-dialog',
    templateUrl: './cookie-dialog.component.html',
    styleUrls: ['./cookie-dialog.component.scss']
})
export class CookieDialogComponent extends BaseComponent implements OnInit {

    cookieSettings: CookieSettingsModel;
    isAdvancedSettingsView = false;

    constructor(@Inject(MAT_DIALOG_DATA) public data: { cookieTypes: CookieTypesEnum[] },
                private dialogRef: MatDialogRef<CookieDialogComponent>, private appService: AppService) {
        super();
        this.cookieSettings = this.appService.getCookiesAllowed();
        if (!this.cookieSettings) {
            this.cookieSettings = new CookieSettingsModel();
        }
    }

    ngOnInit(): void {
        this.dialogRef.disableClose = true;
    }

    checkCookieType(cookieType: string) {
        if (this.data.cookieTypes && this.data.cookieTypes.length > 0) {
            return this.data.cookieTypes.find(t => t === cookieType);
        } else {
            return false;
        }
    }

    allowCookies() {
        this.appService.allowCookies(this.cookieSettings);
        this.appService.reprocessCookie();
        this.dialogRef.close();
    }

    allowOnlyNecessaryCookies() {
        this.cookieSettings = new CookieSettingsModel();
        this.appService.allowCookies(this.cookieSettings);
        this.appService.reprocessCookie();
        this.dialogRef.close();
    }

    allowAllCookies() {
        const cookieSettings = new CookieSettingsModel();
        cookieSettings.allowAllCookies();
        this.appService.allowCookies(cookieSettings);
        this.appService.reprocessCookie();
        this.dialogRef.close();
    }

    changeCookieView() {
        this.isAdvancedSettingsView = true;
    }
}
